import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { colors } from 'design-system';
import { ReactElement } from 'react';
import { XCircle } from 'react-feather';
import { FilterOption } from '../../models/Filter';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(1, 1),
    },
    tag: {
      borderRadius: theme.spacing(2.5),
      border: `1px solid ${colors.madison}`,
      minWidth: theme.spacing(13.75),
    },
    container: {
      padding: theme.spacing(0.5, 2),
      width: '100%',
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'center',
    },
  }),
);

interface Props {
  filter: FilterOption;
  onClick?: (filter: FilterOption) => void;
  inputId?: string;
}

// Component that represents an active filter tag.
export default function FilterTag({
  filter,
  onClick,
  inputId,
}: Props): ReactElement {
  const classes = useStyles();
  const { description } = filter;

  function handleClick() {
    if (onClick) {
      onClick(filter);
    }
  }

  return (
    <div className={classes.root} id={inputId}>
      <ButtonBase className={classes.tag} onClick={handleClick}>
        <div className={classes.container}>
          <Typography
            variant="caption"
            align="center"
            style={{ marginRight: '5px' }}
          >
            {description}
          </Typography>
          <XCircle color={colors.madison} strokeWidth="1px" />
        </div>
      </ButtonBase>
    </div>
  );
}
